import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'Components/molecules/Heading';
import { Image } from 'Components/atoms/Image';
import { ReportCard } from 'Components/organisms/ReportCard';
import { AtAGlanceCard } from 'Components/organisms/AtAGlanceCard';
import { withPolaris } from 'Components/protons/Polaris';
import './_style.scss';

const AtAGlanceContainer = ({
  context: {
    cssPrefix,
  },
  title,
  atAGlanceListNum,
  atAGlanceData, // Pass to AtAGlanceCard
  reviewData,
  reviewLink, // Pass to AtAGlanceCard
  iconOpen,
  iconClose,
}) => {
  const reportCardCtaTracking = () => {
    window.dataLayer.push({
      event: 'marketplace.button_click',
      'event.type': 'GYC',
      'marketplace_button.placement': 'GYCGlanceCard',
    });
  };

  return (
    <div className={`${cssPrefix}__ataglance-container`}>
      <Heading
        size={2}
        extraClassNames={{
          [`${cssPrefix}__ataglance-container--title`]: true,
        }}
      >
        {`${atAGlanceListNum}. ${title}`}
      </Heading>
      {reviewData?.teaserImage
        && (
          <Image
            src={reviewData.teaserImage.src}
            alt={reviewData.teaserImage.alt}
            height={reviewData.teaserImage.height}
            width={reviewData.teaserImage.width}
            size="primary-image"
            extraClassNames={{
              [`${cssPrefix}__ataglance-container--img`]: true,
            }}
          />
        )}
      <div className={`${cssPrefix}__ataglance-container--details`}>
        <ReportCard
          cons={reviewData?.cons}
          consIcon=""
          consLabel="Cons"
          ctas={[
            {
              ...reviewData?.marketplaceLink,
              onClick: reportCardCtaTracking,
            },
          ]}
          extraClassNames={{
            [`${cssPrefix}__ataglance-container--reportcard`]: true,
          }}
          layout="oneColumn"
          priceOptions={{
            min: reviewData?.priceMin,
            max: reviewData?.priceMax,
          }}
          rrpSavingsPriceOptions={{
            min: reviewData?.newCarDealsPricing?.vehicleFinanceData?.rrpSaving,
            minOnly: true,
            postText: ' off RRP*',
          }}
          pros={reviewData?.pros}
          prosIcon=""
          prosLabel="Pros"
          ratings={[
            {
              label: 'Overall rating',
              value: reviewData?.rating,
              showTextRating: true,
              showTextRatingWithTotal: false,
              rounding: 1,
            },
          ]}
          ratingsRounding={1}
          showProsCons
        />
        <AtAGlanceCard
          atAGlanceData={atAGlanceData}
          reviewLink={reviewLink}
          iconOpen={iconOpen}
          iconClose={iconClose}
        />
      </div>
    </div>
  );
};

AtAGlanceContainer.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  atAGlanceListNum: PropTypes.number.isRequired,
  atAGlanceData: PropTypes.shape({
    dimensions: PropTypes.arrayOf(PropTypes.shape({
      info: PropTypes.string,
      value: PropTypes.string,
      title: PropTypes.string,
    })),
    keySpecs: PropTypes.arrayOf(PropTypes.shape({
      info: PropTypes.string,
      value: PropTypes.string,
      title: PropTypes.string,
    })),
  }),
  reviewData: PropTypes.shape({
    cons: PropTypes.arrayOf(PropTypes.string),
    pros: PropTypes.arrayOf(PropTypes.string),
    marketplaceLink: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    priceMax: PropTypes.number,
    priceMin: PropTypes.number,
    rating: PropTypes.number,
    teaserImage: PropTypes.shape({
      src: PropTypes.string,
      height: PropTypes.number,
      width: PropTypes.number,
      alt: PropTypes.string,
    }),
    newCarDealsPricing: PropTypes.shape({
      vehicleFinanceData: PropTypes.shape({
        rrpSaving: PropTypes.number,
      }),
    }),
  }),
  reviewLink: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  iconOpen: PropTypes.string,
  iconClose: PropTypes.string,
};

AtAGlanceContainer.defaultProps = {
  context: {
    cssPrefix: 'polaris',
  },
  atAGlanceData: {},
  reviewData: {},
  reviewLink: {},
  iconOpen: 'polaris__ico-arrow_down',
  iconClose: 'polaris__ico-arrow_up',
};

export default withPolaris(AtAGlanceContainer);
